import { render, staticRenderFns } from "./CustomerModal.vue?vue&type=template&id=a1142fca&"
import script from "./CustomerModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerModal.vue?vue&type=script&lang=ts&"
import style0 from "./CustomerModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports